export function SidePanelIcon() {
  return (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="18" rx="2" />
    <line x1="16" y1="3" x2="16" y2="21" />
    <polyline points="11,12 13,10 13,14 11,12" />
    <line x1="8" y1="12" x2="13" y2="12" />
  </svg>);
}

